module.exports = __webpack_public_path__ + "static/media/login-bg.b09d11bd.jpg";